import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  inputContainer: {
    backgroundColor: 'transparent',
  },

  input: {
    top: 2,
    padding: 0,
    margin: 0,
    flex: 1,
  },

  row: {
    flexDirection: 'row',
  },

  flex: {
    flex: 1,
  },

  accessory: {
    top: 2,
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Textfield/src/components/field/styles.js